import * as Types from '../../types/schema.generated';

import gql from 'graphql-tag';
export type StepDeliveryEditPageContentStepDeliveryPayloadFragment = { __typename?: 'StepDelivery', guid: string, name: string, startAt?: DateString | null, endAt?: DateString | null, cond: string, addFriendDate?: DateString | null, IsDisabled: boolean, steps: Array<{ __typename?: 'StepDeliveryStep', guid: string, stepDeliveryGuid: string, targetDayAfter: number, targetHour: number, message: string, answerSelections?: Array<{ __typename?: 'StepDeliveryStepAnswerSelection', guid: string, stepDeliveryStepGuid: string, selection: string }> | null }> };

export const StepDeliveryEditPageContentStepDeliveryPayloadFragmentDoc = gql`
    fragment StepDeliveryEditPageContentStepDeliveryPayload on StepDelivery {
  guid
  name
  startAt
  endAt
  cond
  addFriendDate
  IsDisabled
  steps {
    guid
    stepDeliveryGuid
    targetDayAfter
    targetHour
    message
    answerSelections {
      guid
      stepDeliveryStepGuid
      selection
    }
  }
}
    `;